export enum JobAccordions {
  JOB_FROM_JOB = 'JOB_FROM_JOB',
  COMMENT = 'COMMENT',
  ADD_FILE = 'ADD_FILE',
  ADD_TIME = 'ADD_TIME'
}

export enum ChecklistFillOutMode {
  FILL_OUT = 'FILL_OUT',
  PREVIEW = 'PREVIEW'
}
